module.exports = __webpack_public_path__ + "img/title_motPhone.723ad9eb.svg";